import { createFileRoute, notFound } from "@tanstack/react-router";
import compareStyles from "../styles/compare.css?url";
import toolStyles from "../styles/tools.css?url";
import { withStylesheet } from "../lib/head";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { loadFeeCalculator } from "../platform/tools";
import { FeeCalculator, type FeeSearch } from "../platform/tools/fee-calculator";

const fields = [
  "members",
  "price",
  "plan",
  "method",
  "currency",
  "iphone",
  "iphonePrices",
  "payout",
];

/**
 * Drate's Patreon fee calculator (Drate's host only). A submitted form arrives as the address's
 * query, so the first answer reads without script.
 */
export const Route = createFileRoute("/tools/patreon-fee-calculator")({
  validateSearch: (search: Record<string, unknown>): FeeSearch =>
    Object.fromEntries(
      fields.flatMap((name) =>
        typeof search[name] === "string" || typeof search[name] === "number"
          ? [[name, String(search[name])]]
          : [],
      ),
    ),
  loader: async () => {
    const page = await loadFeeCalculator();
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) =>
    loaderData
      ? withStylesheet(
          withStylesheet(
            platformPageHead(platformShellFrom(matches), {
              pathname: loaderData.path,
              title: "Patreon fee calculator: what you really keep | Drate",
              description:
                "See what Patreon takes from your memberships: the 10% fee, card processing, currency and payout fees, and Apple’s cut on iPhone. Free, no sign-up.",
              canonicalPath: loaderData.path,
              structuredData: loaderData.structuredData,
            }),
            compareStyles,
          ),
          toolStyles,
        )
      : {},
  component: Calculator,
});

function Calculator() {
  return <FeeCalculator page={Route.useLoaderData()} search={Route.useSearch()} />;
}
